import type { FontProps } from '../types.ts';

export const BASELINE_SUB = -0.3;
export const BASELINE_SUPER = 0.45;
export const SUBSCRIPT_SIZE = 0.7;

export const FONT_DEFAULTS: FontProps = {
  // family: 'sans-serif',
  weight: 400,
  style: 'normal',
  variant: 'normal',
  baseline: 0,
  tracking: 0,
  href: ''
};
